import { Injectable } from '@angular/core';
import { Observable } from 'rxjs/Observable';
import { Resolve, RouterStateSnapshot, ActivatedRouteSnapshot } from '@angular/router';
import 'rxjs/add/operator/map';

import { Permission } from './permission.model';
import { PermissionService } from './permission.service';

@Injectable()
export class PermissionResolver implements Resolve<Permission | Permission[]> {
  constructor(private permissionService: PermissionService) {}

  resolve(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): Observable<Permission | Permission[]> {
    if ('permissionId' in route.params) {
      return this.permissionService.getById(route.params.permissionId);
    }
    return this.permissionService.get();
  }
}



// WEBPACK FOOTER //
// ./src/app/core/data/permissions/permission.resolver.ts